export default class EventOptionAvailabilityTypes {
    id: number
    description: string
}

export enum EventOptionAvailabilityTypesEnum {
    Einzel = 1,
    Team,
    Beide
}